import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from "../../atoms/dialog";
import UndoRedo from "../../tabs/UndoRedo"

export default function UndoRedoAlert({ onClose }) {
    return (
        <Dialog
            title={"Undo/Redo"}
            handleClose={() => onClose()}
            open={true}
            paperProps={{ style: { width: 1500, maxWidth: 1500 }, id: "undoRedoModal" }}
        >
            <UndoRedo/>
            <Grid container direction="row" alignItems="center" justify="center" style={{ paddingRight: 25, justifyContent: 'end' }}>
                <Button onClick={onClose} variant="contained" style={{textTransform: 'capitalize'}}>
                    Close
                </Button>
            </Grid>

        </Dialog>
    )
}